import { initCookie, initCookieConsent } from "./libs/cookie-consent-lib/cookieConsent";

export async function init() {
	if (document.querySelector('[data-map]')) {
		const { initVictoryMap } = await import("./libs/victorymap-lib/victorymap");
		initVictoryMap();
	}
	if (document.querySelector('[data-dropdown]')) {
		const { initDropdowns } = await import("./libs/dropdown-lib/index");
		initDropdowns();
	}
	if (document.querySelector('[data-modal]')) {
		const { initVgmodals } = await import("./libs/modals-lib/initVgmodals");
		initVgmodals();
	}
	if (document.querySelector('.date-input')) {
		const { initDatePicker } = await import("./libs/dateDatePicker-lib/initDatePicker");
		initDatePicker();
	}
	if (document.querySelector('input[type="tel"]')) {
		const { initMask } = await import("./libs/mask-lib/initMask");
		initMask();
	}
	if (document.querySelector('[data-move]')) {
		const { initMovers } = await import("./libs/mover-lib/initMovers");
		initMovers();
	}
	const hasMenu =
		document.querySelector('[data-menu]') &&
		document.querySelector('[data-burger]');

	const hasMobileSearch =
		document.querySelector('[data-mobile-search-panel]') &&
		document.querySelector('[data-mobile-search-trigger]');

	if (hasMenu || hasMobileSearch) {
		const { initOpener } = await import("./libs/opener-lib/");

		if (hasMenu) {
			initOpener({
				name: "menu",
				buttonSelector: "[data-burger]",
				hostSelector: "[data-menu]",
			});
		}

		if (hasMobileSearch) {
			initOpener({
				name: "mobile-search",
				buttonSelector: "[data-mobile-search-trigger]",
				hostSelector: "[data-mobile-search-panel]",
				closeOnOutside: true,
			});
		}
		if (document.querySelector('#confirm-btn')) {
			const { initVgAlert } = await import("./libs/alerts-lib/initVgAlerts");
			initVgAlert();
		}
	}

	const hasVgSelect = document.querySelector('select.vgselect');
	if (hasVgSelect) {
		const { initVgSelect } = await import('./libs/select-lib/vgselect');
		initVgSelect();
	}
	initCookieConsent({
		type: 'column',
		theme: 'light',
		hasCloseButton: false,
		positionX: 'center',
		positionY: 'top',
		cookieTitle: 'Сайт использует cookie',
		cookieTextHTML: `<p>Мы используем файлы cookie, чтобы сайт работал лучше,
			а вы — комфортнее. Продолжая пользоваться сайтом,
			вы соглашаетесь с политикой обработки данных.</p>`,
		buttonText: 'Принять и закрыть',
		expireDays: 30,
		onAccept: initCookie,
	});
}